import AuAlertComponent from '@appuniversum/ember-appuniversum/components/au-alert';
import { CrossIcon } from '@appuniversum/ember-appuniversum/components/icons/cross';

export default class LoadingAlertComponent extends AuAlertComponent {
  CrossIcon = CrossIcon;
}
